import { useState } from "react";
import useDeliveryPickupAxios, { useDeliveryPickupFormData } from "../utils/axios";
import { useDispatch } from "react-redux";
import { setCancelledOrdersCount, setOrdersCount, setOutOfDeliveryOrdersCount } from "../features/DeliveryOrdersCountSlice";
import { setDriverLocation } from "../features/overviewSlice";


function useDeliveryOrderApi () {

    const DeliveryPortalAxios = useDeliveryPickupAxios();
    const DeliveryPortalAxios1 = useDeliveryPickupFormData();
    const DeliveryPortalClient = DeliveryPortalAxios;
    DeliveryPortalClient.defaults.timeout = 600000;
    const DeliveryPortalClient1 = DeliveryPortalAxios1;
    DeliveryPortalClient1.defaults.timeout = 600000;

    const [newOrders, setOrders] = useState([]);
    const [newOrdersLoading, setNewOrdersLoading] = useState(false);
    const [cancelledOrdersLoading, setCancelledOrdersLoading] = useState(false)
    const [cancelledOrders, setCancelledOrders] = useState([])
    const [totalNbOfPage, setTotalNbOfPage] = useState(1);
    const [totalCount, setTotalCount] = useState(1);
    const [newOrdersCount, setNewOrdersCount] = useState({
        cashWithdrawCount: {
            count: 0,
            amountUSD: 0,
            currencyUSD: "USD",
            amountLBP: 0,
            currencyLBP: "LBP",
            subtitle: ""
        },
        cashDepositCount: {
            count: 0,
            amountUSD: 0,
            currencyUSD: "USD",
            amountLBP: 0,
            currencyLBP: "LBP",
            subtitle: ""
        }
    });

    const [newOrdersTitle, setNewOrdersTilte] = useState("");
    const [cancelledOrderCount, setCancelledOrderCount] = useState({
        cashWithdrawCount: {
            count: 0,
            amountUSD: 0,
            currencyUSD: "USD",
            amountLBP: 0,
            currencyLBP: "LBP",
        },
        cashDepositCount: {
            count: 0,
            amountUSD: 0,
            currencyUSD: "USD",
            amountLBP: 0,
            currencyLBP: "LBP",
  
        }
    });
     
    const [cancelledOrderTitle, setCancelledOrderTitle] = useState("");
    const [outForDeliveryOrdersCount, setOutForDeliveryOrdersCount] = useState({ 
    cashWithdrawCount: {
        count: 0,
        amountUSD: 0,
        currencyUSD: "USD",
        amountLBP: 0,
        currencyLBP: "LBP",
        subtitle: ""
    },
    cashDepositCount: {
        count: 0,
        amountUSD: 0,
        currencyUSD: "USD",
        amountLBP: 0,
        currencyLBP: "LBP",
        subtitle: ""
    }});
    const [outForDeliveryOrdersTitle, setOutForDeliveryOrdersTitle] = useState("");
    const [outForDeliveryOrders, setOutForDeliveryOrders] = useState([]);
    const [outofDeliveryLoading, setOutofDeliveryLoading] = useState(false)


    const dispatch = useDispatch();

    const GetNewOrders = async (pageNb, dateFrom, dateTo, type) => {
        setNewOrdersLoading(true);
        await DeliveryPortalAxios.post("/DeliveryOrder/NewOrders", {
            Page: pageNb,
            PageSize: 10,
            DateFrom: dateFrom,
            DateTo: dateTo,
            Type: type
        }
    ).then((res) => {
        setOrders(res.data.payload.orders);
        if(res.data.payload?.length === 0) {
            setTotalNbOfPage(0);
            setTotalCount(0);
        } else {
            setTotalNbOfPage(res.data.payload.pageCount);
            setTotalCount(res.data.payload?.totalOrdersCount);

        }

        setNewOrdersLoading(false);
    }
  );  
};

    const CancelledOrders = async (pageNb, dateFrom, dateTo, type) => {
        setCancelledOrdersLoading(true);
        await DeliveryPortalAxios.post("/DeliveryOrder/CancelledOrders", {
            Page: pageNb,
            PageSize: 10,
            DateFrom: dateFrom,
            DateTo: dateTo,
            Type: type
        }).then((res) => {
            setCancelledOrders(res.data.payload.orders);
            if(res.data.payload?.length === 0) {
                setTotalNbOfPage(0);
                setTotalCount(0);
            } else {
                setTotalNbOfPage(res.data.payload.pageCount);
                setTotalCount(res.data.payload.totalOrdersCount);
            }
                setCancelledOrdersLoading(false);
            });
        }
        
        
        const GetOutForDeliveryOrders = async (pageNb, dateFrom, dateTo, type) => {
            setOutofDeliveryLoading(true);
            await DeliveryPortalAxios.post("/DeliveryOrder/OutForDeliveryOrders", {
                Page: pageNb,
                PageSize: 10,
                DateFrom: dateFrom,
                DateTo: dateTo,
                Type: type
            }).then((res) => {
                setOutForDeliveryOrders(res.data.payload.orders);
                if(res.data.payload?.length === 0) {
                    setTotalNbOfPage(0);
                    setTotalCount(0);
                } else {
                    setTotalNbOfPage(res.data.payload.pageCount);
                    setTotalCount(res.data.payload.totalOrdersCount);
                }
                    setOutofDeliveryLoading(false);
                });
            }


    const GetNewOrdersCount = async () => {
        try {
        const response = await DeliveryPortalAxios.get("/DeliveryOrder/GetNewOrdersCount");

        if(response && response.data.payload){ 
            const cashWithdrawCount = response.data.payload.cashWithdraw; 
            const cashDepositCount = response.data.payload.cashDeposit;

            setNewOrdersCount({
                cashWithdrawCount, 
                cashDepositCount
            });
            setNewOrdersTilte(response.data.payload.title);
            dispatch(setOrdersCount(response.data.payload.count))
        }
        
        
    } catch (error) {
        console.error("Error fetching New Orders Count", error);
    }
}
const GetCancelledOrdersCount = async () => {
    try {
        const response = await DeliveryPortalAxios.get("/DeliveryOrder/GetCancelledOrdersCount");

        if (response && response.data && response.data.payload) {
            const cashWithdrawCount = response.data.payload.cashWithdraw 
            const cashDepositCount = response.data.payload.cashDeposit 

            setCancelledOrderCount({
                cashWithdrawCount, 
                cashDepositCount
            });

            setCancelledOrderTitle(response.data.payload.title || "");
            dispatch(setCancelledOrdersCount(response.data.payload.count))
    
        }
    } catch (error) {
        console.error("Error fetching Cancelled Order Count", error);
    }
};



    const GetOutForDeliveryOrdersCount = async () => {
        try {
            const response = await DeliveryPortalAxios.get("/DeliveryOrder/GetOutForDeliveryOrdersCount");

            if(response && response.data.payload) {
                const cashWithdrawCount = response.data.payload.cashWithdraw 
                const cashDepositCount = response.data.payload.cashDeposit 
                
                setOutForDeliveryOrdersCount({
                    cashWithdrawCount, 
                    cashDepositCount
                });
                setOutForDeliveryOrdersTitle(response.data.payload.title);
                dispatch(setOutOfDeliveryOrdersCount(response.data.payload.count))
            }
        } catch (error){
            console.error("Error fetching Out of delivery orders", error)
    }
}

const GetDriverLocation = async (transactionId) => {
    try {
        const response = await DeliveryPortalAxios.post("/DeliveryOrder/GetDriverLocation", {
            transactionId: transactionId
        });

        if (response && response.data.payload) {
            const { lat, ln } = response.data.payload;


            const latitude = parseFloat(lat);
            const longitude = parseFloat(ln);

            if (!isNaN(latitude) && !isNaN(longitude)) {
                dispatch(setDriverLocation({ lat: latitude, lng: longitude }));
            } else {
                console.error("Invalid coordinates received from API");
            }
        }
    } catch (error) {
        console.error("Error fetching driver location:", error);
    }
};


    return {
        GetNewOrders,
        newOrders,
        newOrdersLoading,
        totalNbOfPage,
        totalCount,
        CancelledOrders,
        cancelledOrders,
        cancelledOrdersLoading,
        GetNewOrdersCount,
        newOrdersCount,
        newOrdersTitle,
        GetCancelledOrdersCount,
        cancelledOrderCount,
        cancelledOrderTitle,
        GetOutForDeliveryOrdersCount,
        outForDeliveryOrdersCount,
        outForDeliveryOrdersTitle,
        GetOutForDeliveryOrders,
        outForDeliveryOrders,
        outofDeliveryLoading,
        GetDriverLocation
    }
}



export default useDeliveryOrderApi;